<div class="modal-header">
  <h4 class="modal-title">View Document</h4>
  <button type="button" class="close btn btn-outline-danger" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12" *ngIf="docs">
      <ngb-carousel [showNavigationArrows]="showNavigationArrows" [showNavigationIndicators]="showNavigationIndicators">
        <ng-template ngbSlide *ngFor="let image of docs">
          <div class="picsum-img-wrapper">
            <div class="mb-2 row justify-content-around">
              <div class="downloadIcon pointer" (click)="downloadImage(image)"></div>
            </div>
            <img *ngIf="!getType(image)" [src]="image" class="img-fluid" alt="Image">
            <pdf-viewer *ngIf="getType(image)" style="display: block; height: 400px;" [src]="image"
              [render-text]="true"></pdf-viewer>
          </div>
        </ng-template>
      </ngb-carousel>
    </div>
  </div>
</div>